import React from "react";
import { AdminProtectedRoute } from "../../components/admin/AdminProtectedRoute";
import { AdminDashboard } from "./AdminDashboard";

export const ProtectedAdminDashboard: React.FC = () => {
  return (
    <AdminProtectedRoute>
      <AdminDashboard />
    </AdminProtectedRoute>
  );
};

export default ProtectedAdminDashboard;
